"use client";

import styles from './index.module.scss';
import { requestVolumeOptions, proServices } from '../data';

export default function ProRequirements({data, onChange}) {
    const handleServiceToggle = (serviceValue) => {
        const currentServices = data.services || [];
        const isSelected = currentServices.includes(serviceValue);

        if (isSelected) {
            // Remove service
            onChange('services', currentServices.filter(s => s !== serviceValue));
        } else {
            // Add service
            onChange('services', [...currentServices, serviceValue]);
        }
    };

    return (
        <div className={styles.container}>
            <h2>PRO Service Requirements</h2>
            <p className={styles.description}>Help us understand your needs</p>

            <div className={styles.section}>
                <label className={styles.sectionLabel}>
                    Estimated Monthly Service Requests <span className={styles.required}>*</span>
                </label>
                <div className={styles.volumeOptions}>
                    {requestVolumeOptions.map((option) => (
                        <div
                            key={option.value}
                            className={`${styles.volumeCard} ${data.requestVolume === option.value ? styles.selected : ''}`}
                            onClick={() => onChange('requestVolume', option.value)}
                        >
                            <input
                                type="radio"
                                name="requestVolume"
                                value={option.value}
                                checked={data.requestVolume === option.value}
                                onChange={() => onChange('requestVolume', option.value)}
                            />
                            <div className={styles.volumeContent}>
                                <span className={styles.volumeLabel}>{option.label}</span>
                                <span className={styles.volumeDescription}>{option.description}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className={styles.section}>
                <label className={styles.sectionLabel}>
                    Services You Need <span className={styles.required}>*</span>
                    <span className={styles.hint}>Select all that apply</span>
                </label>
                <div className={styles.servicesGrid}>
                    {proServices.map((service) => (
                        <label
                            key={service.value}
                            className={`${styles.serviceCheckbox} ${(data.services || []).includes(service.value) ? styles.checked : ''}`}
                        >
                            <input
                                type="checkbox"
                                value={service.value}
                                checked={(data.services || []).includes(service.value)}
                                onChange={() => handleServiceToggle(service.value)}
                            />
                            <span className={styles.checkmark}></span>
                            <span className={styles.serviceLabel}>{service.label}</span>
                        </label>
                    ))}
                </div>
            </div>

            <div className={styles.section}>
                <label className={styles.sectionLabel}>
                    Additional Requirements or Special Requests
                    <span className={styles.optional}>(Optional)</span>
                </label>
                <textarea
                    className={styles.textarea}
                    placeholder="Tell us about any specific requirements, timelines, or special circumstances we should know about..."
                    rows="4"
                    value={data.additionalServices || ''}
                    onChange={(e) => onChange('additionalServices', e.target.value)}
                />
            </div>
        </div>
    )
}
